import Vue from 'vue';

export default {
  state: {
    show: false,
    text: null,
    type: null,
  },
  mutations: {
    TOGGLE_TOAST(state, value) {
      state.show = value !== undefined ? !!value : !state.show;
    },
    SET_TOAST(state, { text, type = 'error' }) {
      state.text = Array.isArray(text) ? text.join('<br>') : text;
      state.type = type;
    },
  },
  actions: {
    async showToast({ commit }, payload) {
      commit('TOGGLE_TOAST', false);
      await Vue.nextTick();
      commit('SET_TOAST', payload);
      commit('TOGGLE_TOAST', true);
    },
    async hideToast({ commit }) {
      commit('TOGGLE_TOAST', false);
    },
  },
};
